/* @flow */
/* eslint-disable no-shadow, no-unused-vars */

import React from 'react';
import InternalLink from './InternalLink';

import type { InternalLinkProps } from './types';

const DynamicEntityLink = (entity: string, path: string): React.Element => (({
  children,
  className,
  onClick,
  query,
  style,
}: InternalLinkProps): React.Element => (
  <InternalLink
    to={`${path}/${entity}`}
    query={query}
    withProjectPath
    style={style}
    className={className}
    onClick={onClick}
    >
    {children}
  </InternalLink>
));

export default DynamicEntityLink;
